// ink-component
import React from 'react';
import styled from 'styled-components';
import { newFormSectionTokens } from '../../../../tokens/components/NewFormSection/tokens';

export interface NewFormSectionSubtitleProps extends React.HTMLAttributes<HTMLParagraphElement> {}

const NewFormSectionSubtitleElement = styled.p`
  margin-bottom: 10px;
  font-size: ${newFormSectionTokens.FontSizeSubtitleDefault};
  font-weight: ${newFormSectionTokens.FontWeightSubtitleDefault};
  line-height: ${newFormSectionTokens.FontLeadingSubtitleDefault};
`;

/**
 * @purpose Gives extra information about the section
 * @categories form
 * @group NewFormSection
 * @position 4
 * @HTMLType HTMLParagraphElement
 */
function NewFormSectionSubtitle(props: NewFormSectionSubtitleProps) {
  const { children, style, className, ...otherProps } = props;
  return <NewFormSectionSubtitleElement {...otherProps}>{children}</NewFormSectionSubtitleElement>;
}

NewFormSectionSubtitle.displayName = 'NewFormSection.Subtitle';

export default NewFormSectionSubtitle;
